@if ($flowDefinitions() != null) {
    <div class="working-area">
        <!-- Barra de tarefas -->
        <p-toolbar>
            <!-- Ações -->
            <div class="ui-toolbar-group-left">
                <!-- Caixa de Fluxos -->
                <div class="form-inline select-container splitter pr-2" featureHint="flowInbox" featureHintHAlign="right">
                    <label for="flowInboxTitle">Caixa de Fluxos</label>

                    <ngx-select-dropdown [ngModel]="$selectedFlowInboxObject()"
                                         [config]="selectedFlowInboxConfig"
                                         [options]="getOrderedAdminUnitsList()"
                                         (change)="changeFlowInbox($event.value)"
                                         (open)="openFlowInbox()"
                    ></ngx-select-dropdown>
                </div>

                <!-- Contador total -->
                <div class="flow-counter info-highlight info-font">
                    Na raiz da Caixa:
                    {{$flowDefinitions().length > 0 ? $flowDefinitions().length : 'nenhum'}}
                    Fluxo{{$flowDefinitions().length > 1 ? 's' : ''}}
                </div>

                <!-- Contador corrente -->
                <div class="flow-counter info-highlight info-font">
                    Filtro corrente:
                    {{$filteredFlowDefinitions().length > 0 ? $filteredFlowDefinitions().length : 'nenhum'}}
                    Fluxo{{$filteredFlowDefinitions().length > 1 ? 's' : ''}}
                </div>
            </div>

            <!-- Filtros -->
            <div class="ui-toolbar-group-right" featureHint="filterBar">
                <!-- Publicados -->
                <div class="chip-set-container">
                    <span class="chip-set-label">Publicados</span>
                    <mat-chip-set>
                        <mat-chip matTooltip="Apenas Fluxos com a última versão publicada" [class.selected]="$isPublishedFilterOn()" (click)="toggleIsPublished(true)" (keyDown)="toggleIsPublished(true)">
                            <i class="icon fas fa-check"></i>
                        </mat-chip>
                        <mat-chip matTooltip="Ambos" [class.selected]="!$isPublishedFilterOn() && !$isPublishedFilterOff()" (click)="toggleIsPublished()" (keyDown)="toggleIsPublished()">
                            <i class="icon fas fa-minus"></i>
                        </mat-chip>
                        <mat-chip matTooltip="Apenas Fluxos com a última versão não publicada" [class.selected]="$isPublishedFilterOff()" (click)="toggleIsPublished(false)" (keyDown)="toggleIsPublished(false)">
                            <i class="icon fas fa-times"></i>
                        </mat-chip>
                    </mat-chip-set>
                </div>

                <!-- Ativos -->
                <div class="chip-set-container">
                    <span class="chip-set-label">Ativos</span>
                    <mat-chip-set>
                        <mat-chip matTooltip="Apenas ativos" [class.selected]="$isActiveFilterOn()" (click)="toggleIsActive(true)" (keyDown)="toggleIsActive(true)">
                            <i class="icon fas fa-check"></i>
                        </mat-chip>
                        <mat-chip matTooltip="Ambos" [class.selected]="!$isActiveFilterOn() && !$isActiveFilterOff()" (click)="toggleIsActive()" (keyDown)="toggleIsActive()">
                            <i class="icon fas fa-minus"></i>
                        </mat-chip>
                        <mat-chip matTooltip="Apenas inativos" [class.selected]="$isActiveFilterOff()" (click)="toggleIsActive(false)" (keyDown)="toggleIsActive(false)">
                            <i class="icon fas fa-times"></i>
                        </mat-chip>
                    </mat-chip-set>
                </div>

                <!-- Customizado -->
                <div class="input-container">
                    <input type="text" class="form-inline" placeholder="Filtrar pelo nome do Fluxo" (change)="runFilter()" (keyup)="0" #inputFilterRef />
                    <button type="button" class="btn btn-outline-danger clear" matTooltip="Limpar filtro por nome do Fluxo" (click)="clearFilter()" (keyDown)="clearFilter()">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </p-toolbar>
    </div>

    <canvas-list [_filteredFlowDefinitions]="$filteredFlowDefinitions()"
                 [_selectedFlowInboxObject]="$selectedFlowInboxObject()"
                 (_refreshEvent)="ngOnInit($event)">
    </canvas-list>
}
